import React, { useEffect, useState } from 'react'
import classes from './Recommneted.module.css'
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectRecommend } from "../featurs/movie/movieSlice";

function Recmnated(recommendy) {
 
 let setRight = recommendy.recommendy.filter((item) => {
    console.log(item.type);
    return item.type === "recommend";
  });
  useEffect(()=>{
console.log(setRight)
  },[setRight])
    const movies = useSelector(selectRecommend);
    console.log(recommendy)
    console.log(movies, ":🛢️");
  return (
    <div className={classes.container}>
    Recommend for You
    <div className={classes.recomends}>
    {
  setRight && setRight.map((item) => (
    <Link to={`/details/:${item.id}`}>
    <div key={item.id} className={classes.recomend}>
      <img src={item.cardImg} alt="" />
    </div>
    </Link>
  ))
}
     
    </div>
    </div>
  )
}

export default Recmnated
